import type { MailboxInfo } from 'owa-client-types';
import copilotSettingsStore from '../store/store';

/**
 * Determines if Chat is the only enabled copilot feature for the given mailbox.
 * Returns true if copilot is enabled, Chat feature is enabled, and no other features are enabled.
 * @param mailboxInfo - The mailbox information to check copilot settings for
 * @returns true if Chat is the only enabled copilot feature, false otherwise
 */
export function isChatTheOnlySupportedCopilotScenario(mailboxInfo: MailboxInfo): boolean {
    const store = copilotSettingsStore(mailboxInfo);

    // If copilot is not enabled or no features are available, return false
    if (!store.isEnabled || store.featureInfo.size === 0) {
        return false;
    }

    const enabledFeatures = [...store.featureInfo.entries()].filter(
        ([, featureInfo]) => featureInfo.isEnabled
    );

    // Check if exactly one feature is enabled and it's Chat
    return enabledFeatures.length === 1 && enabledFeatures[0][0] === 'MChat';
}
